import React, { useState, useEffect } from 'react';

const SwipeableMenu = ({ isOpen, onClose, children }) => {
  const [hasEverOpened, setHasEverOpened] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setHasEverOpened(true);
    }
  }, [isOpen]);

  // Prevent initial render flash completely on reload / first mount
  if (!isOpen && !hasEverOpened) {
    return null;
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Menú de navegación lateral"
      className={
        "fixed overflow-hidden z-50 bg-black/60 backdrop-blur-sm inset-0 transform ease-in-out " +
        (isOpen
          ? " transition-opacity opacity-100 duration-500 translate-x-0 "
          : " transition-all delay-500 opacity-0 translate-x-full pointer-events-none invisible ")
      }
    >
      <aside
        className={
          "w-64 max-w-lg right-0 absolute bg-gray-900 h-full shadow-2xl delay-400 duration-500 ease-in-out transition-all transform " +
          (isOpen ? " translate-x-0 " : " translate-x-full ")
        }
      >
        <div className="relative w-64 max-w-lg pb-10 flex flex-col space-y-6 overflow-y-auto h-full p-4">
          {children}
        </div>
      </aside>
      <div
        className="w-screen h-full cursor-pointer"
        onClick={onClose}
        aria-hidden="true"
      />
    </div>
  );
};

export default SwipeableMenu;

